import { PROTECTED } from 'lib/routes'
import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from '@chakra-ui/react';

const NameButton = ({ user }) => {
    const handleClick = (e)=>{
        e.stopPropagation()
    }
    return (
        <Button onClick={handleClick} className='button' as={Link} to={`${PROTECTED}/profile/${user.id}`} colorScheme='teal' variant="link">
            {user.name} {user.lastname}
        </Button>
    )
}

export default NameButton